var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "side-menu" },
    [
      _c(
        "div",
        {
          staticClass: "logo-wrap",
          class: { collapse: _vm.collapse },
          on: { transitionend: _vm.onTransitionend },
        },
        [
          _c(
            "div",
            { staticClass: "logo" },
            [
              _c("el-image", {
                attrs: { src: require("../../assets/img/logo.png") },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "collapse-btn", on: { click: _vm.handleCollapse } },
            [_c("i", { class: _vm.toggleIconClass })]
          ),
        ]
      ),
      _c(
        "el-scrollbar",
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activePath,
                collapse: _vm.collapse,
                router: "",
                "background-color": "#333333",
                "text-color": "#CFD1D8",
                "active-text-color": "#FFFFFF",
                "collapse-transition": false,
              },
            },
            [
              _vm._l(_vm.menus, function (menu, i) {
                return [
                  menu.subMenus
                    ? _c(
                        "el-submenu",
                        {
                          key: `sub_menu_${i}`,
                          style: _vm.menuItemStyle,
                          attrs: { index: menu.url },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("i", { class: `iconfont ${menu.icon}` }),
                            _c("span", {
                              attrs: { slot: "title" },
                              domProps: { textContent: _vm._s(menu.name) },
                              slot: "title",
                            }),
                          ]),
                          _vm._l(menu.subMenus, function (subMenu, j) {
                            return [
                              _c(
                                "el-menu-item",
                                {
                                  key: `sub_menu_item${j}`,
                                  attrs: { index: subMenu.url },
                                },
                                [_vm._v(" " + _vm._s(subMenu.name) + " ")]
                              ),
                            ]
                          }),
                        ],
                        2
                      )
                    : _c(
                        "el-menu-item",
                        {
                          key: `menu_${i}`,
                          style: _vm.menuItemStyle,
                          attrs: { index: menu.url },
                        },
                        [
                          _c("i", { class: `iconfont ${menu.icon}` }),
                          _c("span", {
                            attrs: { slot: "title" },
                            domProps: { textContent: _vm._s(menu.name) },
                            slot: "title",
                          }),
                        ]
                      ),
                ]
              }),
            ],
            2
          ),
          _c(
            "button",
            { staticClass: "ai-msl", on: { click: _vm.openAIMSL } },
            [
              _c("i", { staticClass: "icon ion-md-lock" }),
              _c("i", {
                staticClass: "el-icon-thumb",
                staticStyle: { "padding-right": "10px" },
              }),
              _vm._v("LIMI"),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }